import {Typography} from "cwb-react"

export const PageTitle = ({title, children, className}) => <Typography className={className} component="h1" variant="h2">{children || title}</Typography>